import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22index.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22./rubik.ttf%22,%22variable%22:%22--font-rubik%22}],%22variableName%22:%22rubik%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'rubik', 'rubik Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
